import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const rolepermissionInit = {
  rolepermissions: {},
  isLoadingRolePermissions: false,
};

function rolepermissionReducer(draft, { type, payload }) {
  switch (type) {
    case "setRolePermissions": {
      payload.RolePermissions.forEach(
        (rolepermission) => (draft.rolepermissions[[rolepermission.id]] = rolepermission)
      );
      break;
    }
    case "setIsLoadingRolePermissions": {
      draft.isLoadingRolePermissions = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [RolePermissionContext, RolePermissionDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function RolePermissionProvider({ children }) {
  const [rolepermissionStore, dispatch] = useImmerReducer(rolepermissionReducer, rolepermissionInit);

  return (
    <RolePermissionContext.Provider value={rolepermissionStore}>
      <RolePermissionDispatchContext.Provider value={dispatch}>
        {children}
      </RolePermissionDispatchContext.Provider>
    </RolePermissionContext.Provider>
  );
}

export function useRolePermissionStore() {
  return useContext(RolePermissionContext);
}

export function useRolePermissionDispatch() {
  return useContext(RolePermissionDispatchContext);
}